import Delegate from 'ftdomdelegate'

import Responsive from '../tools/responsive'
import Dom from '../tools/dom'
import Animation from '../tools/animation'

export default class Collapsible {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this._attachListeners();
  }

  _attachListeners() {
    this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
  }

  /**
   * Toggle a given collapsible
   */

  _toggleCollapsible(event, target) {
    var _this14 = this;

    // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
    var parentCollapsible = target.closest('.collapsible');

    if (parentCollapsible.classList.contains('collapsible--autoExpand') && Responsive.matchesBreakpoint('tablet-and-up')) {
      return;
    }

    var isOpen = target.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this._close(parentCollapsible, target);
    } else {
      this._open(parentCollapsible, target);
    }

    // We make sure to close any siblings collapsible as well
    Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
      return _this14._close(collapsibleToClose);
    });
    event.preventDefault();
  }

  /**
   * Open a given collapsible
   */

  _open(collapsible) {
    var toggleButton = collapsible.querySelector('.collapsible__button'),
        collapsibleInner = collapsible.querySelector('.collapsible__inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
      return; // It's already open
    }

    toggleButton.setAttribute('aria-expanded', 'true');
    collapsibleInner.style.overflow = 'visible';
    Animation.slideDown(collapsibleInner);
  }

  /**
   * Close a given collapsible
   */

  _close(collapsible) {
    var toggleButton = collapsible.querySelector('.collapsible__button'),
        collapsibleInner = collapsible.querySelector('.collapsible__inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
      return; // It's already closed
    }

    toggleButton.setAttribute('aria-expanded', 'false');
    collapsibleInner.style.overflow = 'hidden';
    Animation.slideUp(collapsibleInner);
  }
}